import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ListPeriodsResponse } from '@/api/handlers/resources/periods/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { PeriodQueryKeys } from './periodQueryKeys';

/**
 * The selected fiscal year's monthly periods with their statuses and contents.
 * Disabled until a year is selected. Never rejects — branch on `data.success`.
 */
export const useFiscalYearPeriodsQuery = (fiscalYearId: string | null) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<ListPeriodsResponse>>({
        queryKey: PeriodQueryKeys.list(fiscalYearId ?? ''),
        queryFn: () => apiClient.periods.listPeriods(fiscalYearId!),
        enabled: fiscalYearId !== null,
    });
};
